import { GenIcon } from '../helpers/IconBase.es.js';

const ItalicOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24" },
    child: [
      {
        tag: "path",
        attr: { d: "M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z" }
      }
    ]
  })(props);
};

export { ItalicOutlined };
